import React, { useCallback, useEffect, useState } from "react";
import {getData, postData, postFormData} from '../middleware/apiMiddleware';
import s from './SchoolStudents.module.css';
import { useNavigate } from "react-router-dom";
import {RedButton, GreenButton, BlueButton} from './MyButton';
import {MyInput} from '../components/Utilities/MyInput';

import MyPressButton, {MyGreenPressButton} from '../components/Utilities/MyPressButton';
import SchoolCreateUsers from '../components/SchoolCreateUsers';
import MyComponentLoading from '../components/Utilities/MyComponentLoading';
import Swal from 'sweetalert2';
import {unsecuredCopyToClipboard} from '../middleware/clipboardService';

export default function SchoolStudents(prop) {	
	const navigate = useNavigate();
	
	let schoolId = prop.schoolId;
	const [fetchCompleted, setFetchCompleted] = useState(false);
	const [label, setLabel] = useState('25/26');
	const [users, setUsers] = useState(null);
	const [listUser, setListUser] = useState(false);
	const [batchCreateUser, setBatchCreateUser] = useState(false);
	
	const fetchData = async () => {
		if (!users) {
			await getData('schoolApi/listSchoolStudents?orgId=' + schoolId, navigate)
			.then(res => {
					setUsers(res.data);			
				
					setFetchCompleted(true);
				}
			);
		}
	}
	useEffect(() => {
		//fetchData();
	}, []);
	
  const removeClassFromUser = async (indexU, userId, username, classId, className) => {
    Swal.fire({
      title: 'Remove class ' + className + ' from ' + username,
      text: 'You won\'t be able to revert this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, do it!',
      cancelButtonText: 'No, cancel!',
    }).then((result) => {
      if (result.isConfirmed) {
				let obj = { userId, classId }
        postData("schoolApi/removeClassFromUser", obj, navigate).then(res => {
						if (res.data == 'fail'){
								Swal.fire({
									title: "Error",
									text: "The user has done something in the class",
									icon: "error"
								});
						} else {
							users[indexU]['classes'] = users[indexU]['classes'].filter((u) => u.id !== classId);
							setUsers([...users]);
						}
					}
				);
      }
    });
  };
	
	
	
	return (<div className={s.mainHolder}>
		<div className={s.paramHolder} style={{display:"flex", alignItems:"center", gap:"10px", padding:"5px", flexWrap:"wrap"}}>
			<div className={s.nonClickableTitle} >Mode:</div>
			<MyPressButton isPressed={listUser} clickedAction={()=>{fetchData();setListUser(p=>!p)}} bText="List"/>
			<MyPressButton isPressed={batchCreateUser} clickedAction={()=>{setBatchCreateUser(p=>!p)}} bText="Batch Create Student"/>
		</div>
	
		{
			(batchCreateUser) && (<SchoolCreateUsers schoolId={schoolId} triggerAfterCreate={fetchData} userGroup={5}/>)
		}
		
		{(listUser) && ( <div><div style={{display:"flex", borderBottom:"1px solid #736f94"}}>
			<MyInput inputLabel={"Label"} dataInput={label} changeAction={(e)=>{
				setLabel(e)
			}} />
			<div>
				<BlueButton isEnabled={true} clickedAction={()=>{ 
					let copy = "class\tusername\tnickname\n";

					let copyArray = [];
					
					for(let u of users) {
						let cArray = [];
						for (let c of u.classes) {
							if (c.label == label) {
								cArray.push(c.name);
							}
						}
						if (cArray.length > 0) {
							copyArray.push(cArray.join(',') + "\t" + u.username + "\t" + u.nickname +"\n")
						}
					}
				
					copyArray = copyArray.sort();
					
					unsecuredCopyToClipboard(copy + copyArray.join(''));
				}} bText='to clipboard' />
			</div>
		</div>
		<div className={s.rowHolder}>
			<div style={{flexBasis:"300px"}}>Student</div>
			<div style={{flexBasis:"auto", whiteSpace:"nowrap"}}>Class</div>
		</div>
	
		{(!users) && (<MyComponentLoading />)}
		{ users && (<div>{
			users.map((d, indexD)=>(<div key={indexD} className={s.rowHolder} style={(indexD % 2 == 0) ? {background:"#dae6e8"} :{}}>
				<div style={{flexBasis:"300px"}}>
					<div>({d.userId}){d.username}</div>
					<div>{d.nickname}</div>
				</div>
				<div style={{flexBasis:"auto", whiteSpace:"nowrap", display:"flex", gap:"5px", flexWrap:"wrap", width:"calc(100vw - 400px)"}}>
					{
						d.classes.map((c, indexC) => (<div key={indexC}>
							<RedButton 
								overrideStyle={{padding:"0 5px", margin:"2px",border:"2px solid #6c3d19", color:"#6c3d19", fontWeight:"bold", background:"#fbe8d9", width:"150px"}} isEnabled={true} 
								clickedAction={()=>{removeClassFromUser(indexD, d.userId, d.username, c.id, c.name)}} bText={"(" + c.id + ")"+ c.name} />
						</div>))
					}
				</div>
			</div>))}
			</div>)
		}
		</div>)}
	</div>);
	
}

